(function($) {
	/*----------  Google maps on contact page  ----------*/
 	initMap = function() {
 		var uluru = {
 			lat: 51.663249, 
 			lng: 4.096368
 		};

 		var map = new google.maps.Map(document.getElementById('map'), {
 			zoom: 14,
 			center: {
 				lat: 51.663249, 
 				lng: 4.096368
 			},
 			scrollwheel: false,
 			draggable: false,
 			styles: [
 			{
 				"elementType": "geometry",
 				"stylers": [
 				{
 					"color": "#f5f5f5"
 				}
 				]
 			},
 			{
 				"elementType": "labels.icon",
 				"stylers": [
 				{
 					"visibility": "off"
 				}
 				]
 			},
 			{
 				"elementType": "labels.text.fill",
 				"stylers": [
 				{
 					"color": "#616161"
 				}
 				]
 			},
 			{
 				"elementType": "labels.text.stroke",
 				"stylers": [
 				{
 					"color": "#f5f5f5"
 				}
 				]
 			},
 			{
 				"featureType": "administrative.land_parcel",
 				"elementType": "labels.text.fill",
 				"stylers": [
 				{
 					"color": "#bdbdbd"
 				}
 				]
 			},
 			{
 				"featureType": "poi",
 				"elementType": "geometry",
 				"stylers": [
 				{
 					"color": "#eeeeee"
 				}
 				]
 			},
 			{
 				"featureType": "poi",
 				"elementType": "labels.text.fill",
 				"stylers": [
 				{
 					"color": "#757575"
 				}
 				]
 			},
 			{
 				"featureType": "poi.park",
 				"elementType": "geometry",
 				"stylers": [
 				{
 					"color": "#e5e5e5"
 				}
 				]
 			},
 			{
 				"featureType": "poi.park",
 				"elementType": "labels.text.fill",
 				"stylers": [
 				{
 					"color": "#9e9e9e"
 				}
 				]
 			},
 			{
 				"featureType": "road",
 				"elementType": "geometry",
 				"stylers": [
 				{
 					"color": "#ffffff"
 				}
 				]
 			},
 			{
 				"featureType": "road.arterial",
 				"elementType": "labels.text.fill",
 				"stylers": [
 				{
 					"color": "#757575"
 				}
 				]
 			},
 			{
 				"featureType": "road.highway",
 				"elementType": "geometry",
 				"stylers": [
 				{
 					"color": "#dadada"
 				}
 				]
 			},
 			{
 				"featureType": "road.highway",
 				"elementType": "labels.text.fill",
 				"stylers": [
 				{
 					"color": "#616161"
 				}
 				]
 			},
 			{
 				"featureType": "road.local",
 				"elementType": "labels.text.fill",
 				"stylers": [
 				{
 					"color": "#9e9e9e"
 				}
 				]
 			},
 			{
 				"featureType": "transit.line",
 				"elementType": "geometry",
 				"stylers": [
 				{
 					"color": "#e5e5e5"
 				}
 				]
 			},
 			{
 				"featureType": "transit.station",
 				"elementType": "geometry",
 				"stylers": [
 				{
 					"color": "#eeeeee"
 				}
 				]
 			},
 			{
 				"featureType": "water",
 				"elementType": "geometry",
 				"stylers": [
 				{
 					"color": "#c9c9c9"
 				}
 				]
 			},
 			{
 				"featureType": "water",
 				"elementType": "labels.text.fill",
 				"stylers": [
 				{
 					"color": "#9e9e9e"
 				}
 				]
 			}
 			]
 		});

 		var locations = [
 		['Oudestraat 14', 51.663249, 4.096368, 1]
 		];

 		var marker, i;

 		for (i = 0; i < locations.length; i++) {
 			marker = new google.maps.Marker({
 				position: new google.maps.LatLng(locations[i][1], locations[i][2]),
 				map: map,
				icon: '/wp-content/themes/oomsinstallaties/assets/images/marker-ooms.png'
 			});
 		}
 	};
})(jQuery); 
